import React, { useEffect } from 'react';
import './App.css';
import { HashRouter as Router, Link, Route, withRouter } from 'react-router-dom';
import Home from "./views/Home";
import ArticleList from "./views/ArticleList";
import Index from "./views/Index";
import { initShare } from "./utils/share"
// import { getUserInfo } from "./utils/getUserInfo"
import { initShence } from "./utils/buryPoint"
import { useState } from 'react';
import { getTab } from './services/home'
import { ColumnIdTab } from './services/request'
import { savePoint } from "./services/savePoint"

let navFlagStorge = sessionStorage.getItem("tabFlag");
(function () {
  function t() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (t) {
      var e = (16 * Math.random()) | 0
      return ('x' == t ? e : (3 & e) | 8).toString(16)
    })
  }
  var e = 'nfplus_deviceid'
  if (
    (function () {
      var t = 'localstorage_support_test',
        e = window.sessionStorage
      try {
        return e.setItem(t, 'testValue'), e.removeItem(t), !0
      } catch (t) {
        return !1
      }
    })()
  ) {
    var n = window.localStorage.getItem(e) || ''
    return '' == n && ((n = t()), window.localStorage.setItem(e, n)), n
  }
  return t()
})()
const Nav = withRouter(function Two(props) {
  const [tabName1, setTabName1] = useState("")
  const [tabName2, setTabName2] = useState("")
  const [tabId, setTabId] = useState("")
  const [navFlag, setNavFlag] = useState("1")

  useEffect(() => {
    getTabName()
    // if(navFlagStorge) {
    //   setNavFlag(navFlagStorge)
    // }else{
    //   setNavFlag(navFlagStorge)
    // }
  }, [])
  const clearStroge = () => {
    localStorage.setItem("homeIndex", "")
    localStorage.setItem("articleST", "")
    localStorage.setItem("articlePN", "")
    localStorage.setItem("articleTab", "")
    localStorage.setItem("articleListIndex", "")
  }

  // 获取tab的name
  const getTabName = async () => {
    try {
    //   const res = await getTab({
    //     parentColumnId: ColumnIdTab,
    //     v: "6.7.0"
    //   })
    //   setTabName1(res?.data?.columns[0]?.columnName.substr(0,8))
    //   setTabName2(res?.data?.columns[1]?.columnName.substr(0,8))
      setTabName1("重点速读");
      setTabName2("深度学习");
    //   setTabId(res?.data?.columns[1]?.columnId)
    } catch (e) {
      console.error(e)
    }
  }
  return (
    <div className="App-tab" style={{display: props.location.pathname === '/' ? "none" : ""}}>
      <Link to="/home" className={props.location.pathname === '/home' ? "on" : ""} onClick={clearStroge}>
        <img src={props.location.pathname === '/home' ? require("./assets/icon_home_n.png") : require("./assets/icon_home_s.png")}/>{tabName1}
      </Link>
      <Link to="/articleList" className={props.location.pathname === '/articleList' ? "on" : ""} onClick={() => {
        clearStroge()
        const deviceid = window.localStorage.getItem("nfplus_deviceid") || ''
        savePoint({
          dataType: "1000099",
          actionTime: Date.now(),
          refer: "",
          url: window.location.href,
          deviceid,
          origin: 8,
          action: 28,
          optionId: tabId,
          optionName: tabName2
        })
      }}>
        <img src={props.location.pathname === '/articleList' ? require("./assets/icon_list_n.png") : require("./assets/icon_list_s.png")}/>{tabName2}
      </Link>
    </div>
  )
})
var isPageHide = false;
window.addEventListener('pageshow', function () {
  if (isPageHide) {
    window.location.reload();
  }
});
window.addEventListener('pagehide', function () {
  isPageHide = true;
});
const App = function() {
  // const [tabName1, setTabName1] = useState("")
  // const [tabName2, setTabName2] = useState("")
  // const [tabId, setTabId] = useState("")
  // const [navFlag, setNavFlag] = useState("1")

  // useEffect(() => {
  //   getTabName()
  //   // if(navFlagStorge) {
  //   //   setNavFlag(navFlagStorge)
  //   // }else{
  //   //   setNavFlag(navFlagStorge)
  //   // }
  // }, [])
  // const clearStroge = () => {
  //   localStorage.setItem("homeIndex", "")
  //   localStorage.setItem("articleST", "")
  //   localStorage.setItem("articlePN", "")
  //   localStorage.setItem("articleTab", "")
  // }

  // // 获取tab的name
  // const getTabName = async () => {
  //   try {
  //     const res = await getTab({
  //       parentColumnId: ColumnIdTab,
  //       v: "6.7.0"
  //     })
  //     setTabName1(res?.data?.columns[0]?.columnName)
  //     setTabName2(res?.data?.columns[1]?.columnName)
  //     setTabId(res?.data?.columns[1]?.columnId)
  //   } catch (e) {
  //     console.error(e)
  //   }
  // }
  const [isPaused, setPaused] = useState(true);

  const playMusic = async () => {
    let audio = document.getElementById('audio');
    if (audio.paused) {
      audio.play();
      setPaused(false);
    } else {
      audio.pause();
      setPaused(true);
    }
  }

  const setAutoPlay = () => {
    document.addEventListener(
      "WeixinJSBridgeReady",
      function() {
        let audio = document.getElementById('audio');
        audio.play();
        if (!audio.paused) {
          setPaused(false);
        }
      },
      false
    );
    document.addEventListener(
      "visibilitychange",
      function() {
        if (document.visibilityState === "visible") {
          let audio = document.getElementById('audio');
          if (!isPaused) {
            audio.play();
          }
        }
        if (document.visibilityState === "hidden") {
          let audio = document.getElementById('audio');
          if (!audio.paused) {
            audio.pause();
          }
        }
      },
      false
    );
    let audio = document.getElementById('audio');
    audio.play();
  }

  useEffect(() => {
    initShare()
    let userUuid = localStorage.getItem("WX_LOGIN_UUID")
    initShence({
      deviceId: "",
      userUuid: userUuid || ""
    })
    // getUserInfo()
    // 加载中样式隐藏
    let loading = document.querySelector(".loading-fffff")
    loading && (loading.style.display = "none")

    // setAutoPlay()
    
  }, [])


  return (
    <Router>
      <div className="App">
        <div className="musicarea">
          <div className={`music ${!isPaused ? 'move': ''}`} onClick={playMusic}></div>
          <audio id="audio" src="https://res.mp.oeeee.com/h5static/v21/sjjlzqh/music.mp3" loop></audio>
        </div>

        <div className="App-content" >
          {/* {navFlag == "1" ? (
            <Home></Home>
          ) : (
              <ArticleList></ArticleList>
            )} */}
          <Route path="/" exact component={Index}></Route>
          <Route path="/home" exact component={Home}></Route>
          <Route path="/articleList" exact component={ArticleList}></Route>
        </div>
        {/* <div className="App-tab">
          <a className={navFlag == "1" ? "on" : ""} onClick={() => {
            setNavFlag("1")
            clearStroge()
            sessionStorage.setItem("tabFlag", "1")
          }}>
            {navFlag == "1" ? (<img src={require("./assets/icon_home_s.png")} alt="" />) : (<img src={require("./assets/icon_home_n.png")} alt="" />)}
            {tabName1}
          </a>
          <a className={navFlag == "2" ? "on" : ""} onClick={() => {
            clearStroge()
            savePoint({
          dataType: "1000099",
          actionTime: Date.now(),
          refer: "",
          url: window.location.href,
          deviceid,
          origin: 8,
          action: 28,
          optionId: tabId,
          optionName: tabName2
        })
            setNavFlag("2")
            sessionStorage.setItem("tabFlag", "2")
          }}>
            {navFlag == "2" ? (<img src={require("./assets/icon_list_s.png")} alt="" />) : (<img src={require("./assets/icon_list_n.png")} alt="" />)}
            {tabName2}
          </a>
        </div> */}
        <Nav></Nav>
      </div>
    </Router>
  );
}

export default App;
